import { Component, computed, inject } from '@angular/core';
import {TitleAyudaComponent} from '../../../../shared/components/title-ayuda-component/title-ayuda-component';
import { ThemeService } from '@/app/core/services/theme/theme.service';


@Component({
  selector: 'app-ayuda-component',
  standalone: true,
  imports: [TitleAyudaComponent],
  templateUrl: './ayuda-component.html',
  styleUrl: './ayuda-component.scss',
})
export class AyudaComponent {
  private themeService = inject(ThemeService); 

  protected pageTitle = 'Ayuda';
  protected themeContent = this.themeService.themeContent;
  protected helpContent = computed(() => this.themeContent()?.helpComponent?.helpSection);

    



}
